import { useState, useCallback } from 'react';
import { useReadOnly, useFocused, useSelected } from 'slate-react';
import type { PlateElementProps } from 'platejs/react';
import Box from '@mui/material/Box';

import { Embed } from 'common/components/Embed';
import { Selectable } from 'common/components/Selectable';
import { List } from 'common/components/List';
import { ListItem } from 'common/components/ListItem';

export const EditorEmbed = ({
    element,
    attributes,
    children,
    className,
}: PlateElementProps) => {
    const { url, html } = element as { url?: string; html?: string };

    const [embedError, setEmbedError] = useState(false);

    const readOnly = useReadOnly();
    const focused = useFocused();
    const selected = useSelected();

    const handleError = useCallback(() => setEmbedError(true), []);

    let embed = <Embed html={html} src={url || ''} onError={handleError} />;

    if (embedError) {
        embed = (
            <List noBorder color="body">
                <ListItem>{embed}</ListItem>
            </List>
        );
    }

    return (
        <div
            className={className}
            {...attributes}
            data-slate-html={html}
            data-slate-url={url}
        >
            <Box contentEditable={false} sx={{ mb: 2 }}>
                {readOnly ? (
                    embed
                ) : (
                    <Selectable blockClick selected={focused && selected}>
                        {embed}
                    </Selectable>
                )}
            </Box>
            {children}
        </div>
    );
};
